// /admin/clientes/comprador/:id — Ficha 360 de un comprador one-shot (no suscriptor).
// Historial de compras real + CTA a convertir en suscripción. La ficha del suscriptor es ClienteDetalle.
import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import AdminLayout from '../../components/AdminLayout'
import { supabase } from '../../lib/supabase'

const fmt = (n) => '$ ' + Math.round(Number(n || 0)).toLocaleString('es-UY')
const ESTADO = {
  entregado: { t: 'Entregado', c: '#059669', bg: '#D1FAE5' },
  en_ruta: { t: 'En ruta', c: '#0369A1', bg: '#E0F2FE' },
  en_armado: { t: 'En armado', c: '#B45309', bg: '#FEF3C7' },
  pagado: { t: 'Pagado', c: '#059669', bg: '#D1FAE5' },
  pendiente_pago: { t: 'Espera pago', c: '#B45309', bg: '#FEF3C7' },
  cancelado: { t: 'Cancelado', c: '#94A3B8', bg: '#F1F5F9' },
  rechazado: { t: 'Pago rechazado', c: '#B91C1C', bg: '#FEE2E2' },
}
const CANCELADO = ['cancelado', 'rechazado']

export default function CompradorDetalle() {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [pedidos, setPedidos] = useState([])
  const [facByPedido, setFacByPedido] = useState({})

  useEffect(() => { cargar() }, [id])  // eslint-disable-line react-hooks/exhaustive-deps
  async function cargar() {
    setLoading(true)
    // Mismo criterio que la Lista de Clientes (segmento one-shot): compra_unica/productos_sueltos,
    // pagadas, no prueba, sin empresa. Asi Gastado/Compras de la ficha cuadran con la fila de la lista.
    const { data: peds } = await supabase.from('pedidos')
      .select('id, numero_orden, created_at, monto_total, costo_envio, estado, items, entrega_direccion, comprador_nombre, comprador_telefono, comprador_email, pagado_at, tipo')
      .eq('comprador_profile_id', id)
      .in('tipo', ['compra_unica', 'productos_sueltos'])
      .not('pagado_at', 'is', null)
      .eq('es_prueba', false).is('empresa_id', null)
      .order('created_at', { ascending: false })
    const lista = peds || []
    setPedidos(lista)
    const ids = lista.map(p => p.id)
    if (ids.length) {
      const { data: facs } = await supabase.from('facturas_emitidas').select('id, pedido_id, serie, numero, estado, pdf_path').in('pedido_id', ids)
      const m = {}; for (const f of (facs || [])) m[f.pedido_id] = f
      setFacByPedido(m)
    }
    setLoading(false)
  }

  const buyer = pedidos[0] || {}
  // Cuadra con la lista: suma todas las compras pagadas del comprador (sin excluir estado).
  const gastado = pedidos.reduce((a, p) => a + Number(p.monto_total || 0), 0)
  const compras = pedidos.length
  const recurrente = compras > 1
  const ultima = pedidos[0]?.created_at
  const inicial = (buyer.comprador_nombre || '?').trim().split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase()

  async function verPdf(pedidoId) {
    const f = facByPedido[pedidoId]
    if (!f?.pdf_path) return alert('Sin PDF disponible.')
    const { data, error } = await supabase.storage.from('facturas-emitidas').createSignedUrl(f.pdf_path, 300)
    if (error || !data?.signedUrl) return alert('No se pudo abrir el PDF.')
    window.open(data.signedUrl, '_blank')
  }
  const wa = buyer.comprador_telefono ? `https://wa.me/${String(buyer.comprador_telefono).replace(/[^0-9]/g, '').replace(/^0/, '').replace(/^(?!598)/, '598')}` : null

  const card = { background: '#fff', border: '1px solid #E2E8F0', borderRadius: 12, boxShadow: '0 1px 2px rgba(16,32,64,.05)', marginBottom: 14, overflow: 'hidden' }
  const cardH = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', borderBottom: '1px solid #EDF1F6', fontWeight: 800, fontSize: 13, color: '#1A3461' }

  return (
    <AdminLayout>
      <div className="page">
        <div style={{ fontSize: 12, color: '#94A3B8', marginBottom: 10 }}>
          <Link to="/admin/clientes" style={{ color: '#0E7490' }}>← Clientes</Link> / <b style={{ color: '#1A3461' }}>{buyer.comprador_nombre || 'Comprador'}</b>
        </div>

        {loading ? (
          <div className="card" style={{ textAlign: 'center', color: 'var(--muted)' }}>Cargando…</div>
        ) : pedidos.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', color: 'var(--muted)' }}>Sin compras registradas para este comprador.</div>
        ) : (
          <>
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, padding: 18, border: '1px solid #E2E8F0', borderRadius: 14, background: 'linear-gradient(180deg,#fff,#F8FBFD)', marginBottom: 16, flexWrap: 'wrap' }}>
              <div style={{ width: 54, height: 54, borderRadius: '50%', background: '#0369A1', color: '#fff', display: 'grid', placeItems: 'center', fontWeight: 800, fontSize: 19, flex: 'none' }}>{inicial}</div>
              <div>
                <h1 style={{ margin: 0, fontSize: 20 }}>
                  {buyer.comprador_nombre || 'Comprador'}{' '}
                  <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 999, background: '#E0F2FE', color: '#0369A1', verticalAlign: 'middle' }}>◆ One-shot</span>
                  {recurrente && <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 999, background: '#FEF3C7', color: '#B45309', verticalAlign: 'middle', marginLeft: 6 }}>★ A convertir</span>}
                </h1>
                <div style={{ fontSize: 12.5, color: '#64748B', marginTop: 3 }}>
                  {buyer.entrega_direccion && <>📍 {buyer.entrega_direccion} &nbsp;·&nbsp; </>}
                  {buyer.comprador_telefono && <>📱 {buyer.comprador_telefono} &nbsp;·&nbsp; </>}
                  primera compra {ultima ? new Date(pedidos[pedidos.length - 1].created_at).toLocaleDateString('es-UY', { month: 'short', year: 'numeric' }) : '—'}
                </div>
              </div>
              <div style={{ marginLeft: 'auto', display: 'flex', gap: 22 }}>
                <div><div style={{ fontSize: 19, fontWeight: 800, color: '#1A3461' }}>{fmt(gastado)}</div><div style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '.4px', color: '#94A3B8', fontWeight: 700 }}>Gastado</div></div>
                <div><div style={{ fontSize: 19, fontWeight: 800, color: '#1A3461' }}>{compras}</div><div style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '.4px', color: '#94A3B8', fontWeight: 700 }}>Compras</div></div>
                <div><div style={{ fontSize: 19, fontWeight: 800, color: '#1A3461' }}>{ultima ? new Date(ultima).toLocaleDateString('es-UY', { day: '2-digit', month: 'short' }) : '—'}</div><div style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '.4px', color: '#94A3B8', fontWeight: 700 }}>Última</div></div>
              </div>
            </div>

            {recurrente && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: 'linear-gradient(90deg,#E1F5EE,#F8FBFD)', border: '1px solid #A7E3D4', borderRadius: 12, padding: '12px 14px', marginBottom: 16, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 20 }}>🔁</span>
                <div style={{ flex: 1, fontSize: 12.5, color: '#065F46', minWidth: 220 }}><b>Compró {compras} veces.</b> Candidato fuerte a suscripción — le ahorrás el re-pedido y fijás el MRR.</div>
                <Link to="/admin/clientes?alta=1" className="btn primary" style={{ textDecoration: 'none' }}>Convertir a suscripción →</Link>
              </div>
            )}

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 280px', gap: 16, alignItems: 'start' }}>
              <div>
                <div style={card}>
                  <div style={cardH}><span>🛒 Historial de compras</span><span style={{ fontSize: 11, color: '#94A3B8', fontWeight: 500 }}>one-shot · tienda web</span></div>
                  <div style={{ padding: '0 14px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                      <tbody>
                        {pedidos.map(p => {
                          const items = Array.isArray(p.items) ? p.items : []
                          const primer = items[0]?.nombre || items[0]?.descripcion || items[0]?.sku || 'Productos'
                          const est = ESTADO[p.estado] || { t: p.estado, c: '#64748B', bg: '#F1F5F9' }
                          const fac = facByPedido[p.id]
                          const cancel = CANCELADO.includes(p.estado)
                          return (
                            <tr key={p.id} style={{ borderBottom: '1px solid #F1F5F9', opacity: cancel ? 0.6 : 1 }}>
                              <td style={{ padding: '9px 4px' }}><b style={{ color: '#1A3461' }}>{p.numero_orden || p.id.slice(0, 8)}</b><div style={{ fontSize: 10.5, color: '#94A3B8' }}>{new Date(p.created_at).toLocaleDateString('es-UY', { day: '2-digit', month: 'short' })}</div></td>
                              <td style={{ padding: '9px 4px', color: '#334155' }}>{primer}{items.length > 1 && <span style={{ color: '#94A3B8' }}> +{items.length - 1} ítems</span>}</td>
                              <td style={{ padding: '9px 4px' }}><span style={{ fontSize: 10.5, fontWeight: 700, padding: '2px 8px', borderRadius: 999, background: est.bg, color: est.c }}>{est.t}</span></td>
                              <td style={{ padding: '9px 4px', textAlign: 'right', fontWeight: 800, color: cancel ? '#94A3B8' : '#1A3461' }}>{fmt(p.monto_total)}</td>
                              <td style={{ padding: '9px 4px', textAlign: 'right' }}>{fac?.pdf_path ? <button onClick={() => verPdf(p.id)} style={{ border: '1px solid #E2E8F0', background: '#fff', borderRadius: 6, padding: '2px 8px', fontSize: 11, cursor: 'pointer', color: '#475569' }}>PDF</button> : fac ? <span style={{ fontSize: 10.5, color: '#94A3B8' }}>{fac.serie}-{fac.numero}</span> : <span style={{ fontSize: 10.5, color: '#CBD5E1' }}>—</span>}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div>
                <div style={card}>
                  <div style={cardH}><span>⚡ Acciones</span></div>
                  <div style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <Link to="/admin/clientes?alta=1" className="btn primary" style={{ textDecoration: 'none', textAlign: 'center' }}>🔁 Convertir a suscripción</Link>
                    <Link to="/admin/ventas-manuales" className="btn ghost" style={{ textDecoration: 'none', textAlign: 'center' }}>🛒 Nueva compra (venta manual)</Link>
                    {wa && <a href={wa} target="_blank" rel="noopener noreferrer" className="btn ghost" style={{ textDecoration: 'none', textAlign: 'center' }}>💬 WhatsApp</a>}
                  </div>
                </div>
                <div style={card}>
                  <div style={cardH}><span>📇 Contacto</span></div>
                  <div style={{ padding: 14, fontSize: 12.5, color: '#475569', lineHeight: 1.7 }}>
                    <div>📱 {buyer.comprador_telefono || '—'}</div>
                    <div>✉️ {buyer.comprador_email || '—'}</div>
                    <div>📍 {buyer.entrega_direccion || '—'}</div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </AdminLayout>
  )
}
